import React from 'react';
import { Controller } from 'react-hook-form';
import { c as classnames } from '../../../index-2586sEvh.js';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import { handleLeadingZeros } from '../../../utils/product.js';
import '../../../_commonjsHelpers-jjO7Zipk.js';
import '../../../context/index.js';
import '../../../paths-ZKN3m62_.js';
import '../../../product-_pRduMz7.js';
import 'next/router';

const InputQuantity = ({ name, labelExtra, control, errors }) => {
    const { t } = useTranslation('');
    const { t: tCommon } = useTranslation('', { keyPrefix: '$common' });
    const errorText = get(errors, `${name}.message`, '');
    const isError = Boolean(errorText);
    const onkeydownHandler = (e) => {
        if (e.key === 'e' || e.key === '-' || e.key === '.') {
            e.preventDefault();
        }
    };
    const onInputHandler = (e) => {
        const event = { ...e };
        let inputValueString = event.currentTarget.value;
        if (inputValueString.charAt(0) === '0') {
            inputValueString = inputValueString.substring(1);
        }
        if (Number(inputValueString) > 99) {
            event.currentTarget.value = '99';
        }
    };
    const onInputChange = (e, onChange) => {
        const inputValueString = e.currentTarget.value;
        const inputValue = Number(inputValueString);
        switch (true) {
            case Number(inputValue) < 0:
                onChange(Math.abs(Number(inputValue)));
                break;
            case Number(inputValue) > 0:
                onChange(inputValue);
                break;
            case Number(inputValue) === 0:
                onChange(inputValue);
                break;
        }
    };
    const onBlurHandler = (value, onChange) => {
        if (!value)
            onChange(1);
    };
    const onFocusHandler = (e) => {
        e.target.select();
    };
    return (React.createElement(Controller, { control: control, name: name, render: ({ field: { value, onChange } }) => (React.createElement("div", { className: "input-quantity" },
            React.createElement("input", { "data-testid": "input-quantity", type: "number", pattern: "\\d*" // only numbers
                , name: name, min: 1, value: handleLeadingZeros(value), className: classnames('input', 'quantity-counter-input', { 'input-error': isError }), onKeyDown: onkeydownHandler, onChange: event => onInputChange(event, onChange), onBlur: () => onBlurHandler(value, onChange), onInput: onInputHandler, "aria-label": tCommon('quantityOf', { productName: labelExtra }), onFocus: onFocusHandler }),
            isError && (React.createElement("div", { className: "error", role: "alert" }, t(errorText.toString()))))) }));
};

export { InputQuantity as default };
//# sourceMappingURL=index.js.map
